
export default function(){
    
    const initialState = {
        disabledRoutes:[],
        warnOnClose: true
    }

    return function(state = initialState, action) {

        switch(action.type){

            //
            case "DISABLE_ROUTES": return {
                ...state,
                disabledRoutes: action.disabledRoutes
            }

            //
            case "SET_CLOSE_WARNING": return {
                ...state,
                warnOnClose: action.value
            }

            //
            default: return state

        }

    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/navigation/navigation-reducer.ts